import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
require('parsley');
require('datatables.net');
require('datatablesResponsive');
require('parsley');
import * as moment from 'moment';
import { bookingFormCommon } from "../c005-bookingform-common";
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";

export class memberAddTraveller {
    $scope: any = $('#lcp_mytraveller_profile_members');
    private addForm:any = $('#member-profile-lcpadd');
	private bookingformcommon = new bookingFormCommon();
    private memberBase:any = new memberPortal() ;$error:Array<any>;
 populatemytravelller()
 {
    let countrycodeurls: string = '';
	var nationalityName = $.Deferred();
	if (window.location.hostname === 'localhost' && window.location.port == '5000') {
		countrycodeurls = '/dummy-data/countrycode.json';
	}
	else {
		countrycodeurls = '/content/dam/mas/json/countrycode.json';
	}
	$.get(countrycodeurls)
		.done((data: any) => {
			var nationalityNameDisp = "";
			if (typeof data === 'string') {
				data = JSON.parse(data);
			}
			nationalityName.resolve(data);

		})
		.fail((error: any) => {
			nationalityName.reject(error);
        });
        
        let populateurl:string = '';
        if (window.location.hostname === 'localhost' && window.location.port == '5000') {
            populateurl = '/dummy-data/addtraveller.json';
        }
        else {
            populateurl = '/bin/services/new/getMytravellerAPI';
        }
        let _self = this;
            let bcommon = _self.bookingformcommon;
            bcommon.preloader();
            $.when(nationalityName).done(function (nationalityArray: any) {
            $.ajax({
                type: 'GET',
                url:populateurl,
                async: false,
                success: function(msg:any) {
                    if(typeof msg==='string'){
                    msg = JSON.parse(msg);
                    }else{
                        msg=msg;
                    }
                    var trHTML = '';
                    $('#member-myadd-lcptraveller .mytraveler-table').remove();
                    $('#member-myadd-lcptraveller .edit_form').remove();
                    $(".tag-lineno").html((msg.travellersDetails.length));
                    if(msg.travellersDetails.length===8)
					{
					 $('.btn-memberadd--submit').css({ 'opacity': '0.5','pointer-events': 'none' });
					 $('#addtraveller_mobileadd').hide();
					}
					else
					{
					$('.btn-memberadd--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });
					$('#addtraveller_mobileadd').show();
					}
                    for(let i=0;i<msg.travellersDetails.length;i++)
                    {	
                        const age = moment().diff(msg.travellersDetails[i].dob, 'years');
                        // var $traveler_type:any;
                        if(age>=12){
                            var traveler_type="Adult";        
                        }		
                        else
                        {
                            var traveler_type="Child";
                        }
                        var expiry_date=msg.travellersDetails[i].expirydate
                        if(expiry_date!=undefined)
                        {
                            expiry_date=msg.travellersDetails[i].expirydate
                        }
                        else
                        {
                            expiry_date="";
                        }
                        var nationalityCode = msg.travellersDetails[i].nationality;
                        var passportIssueCnty = msg.travellersDetails[i].passportissuingcountry;
                            for (var k = 0; k < nationalityArray.Countries.length; k++) {
                                if (nationalityArray.Countries[k].Code == nationalityCode) {
                                    
                                   var nationality=(nationalityArray.Countries[k].Name);

                                } 
                                if (nationalityArray.Countries[k].Code == passportIssueCnty) {
                                    
                                    var country=(nationalityArray.Countries[k].Name);
    
                                } 
                            }
                            let airlinecode=msg.travellersDetails[i].airlinecode
                            switch(airlinecode)
                             {
                             case 'AA' :
                             $("#traveller-airline_"+i).html('American Airlines');
                             var airlinename='American Airlines';
                             break;
                             case 'BA':
                             var airlinename='British Airways';
                             break;
                             case 'KA' :
                             var airlinename='Cathay Dragon';
                             break;
                             case 'CX' :
                             var airlinename='Cathay Pacific';
                             break;
                             case 'EK' :
                             var airlinename='Emirates';	
                             break;
                             case 'EY' :
                             var airlinename='Etihad Airways';	
                             break;
                             case 'AY' :
                             var airlinename='Finnair';
                             break;
                             case 'IB' :
                             var airlinename='Iberia';
                             break;
                             case 'JL' :
                             var airlinename='Japan Airlines';
                             break;
                             case 'KL' :
                             var airlinename='KLM Royal Dutch Airlines';
                             break;
                             case 'LA' :
                             var airlinename='LATAM Airlines Group';
                             break;
                             case 'MH' :
                             var airlinename='Malaysia Airlines';
                             break;
                             case 'QF' :	
                             var airlinename='Qantas Airways';	
                             break;
                             case 'QR' :	
                             var airlinename='Qatar Airways';
                             break;
                             case 'RJ' :				
                             var airlinename='Royal Jordanian';
                             break;
                             case 'S7' :						
                             var airlinename='Siberia Airlines';
                             break;
                             case 'SQ' :						
                             var airlinename='Singapore Airlines';
                             break;
                             case 'UL' :						
                             var airlinename='SriLankan Airlines';
                             break;		
                             }
                             if (airlinename==undefined)
                             {
                                airlinename="";
                             }
                             if (nationality==undefined)
                             {
                                nationality="";
                             }
                             if (country==undefined || passportIssueCnty=="")
                             {
                                country="";
                             }
                        trHTML += '<table class="mytraveler-table responsive" id="my-traveler" "><tbody class="travellers'+(i+1)+'">';
                        trHTML += '<tr><th ><div class="col-lg-1 col-md-2 col-xs-1" style="padding: 0;"><p class="circle-travel">'+(i+1)+'</p></div>'
                        trHTML +='<div class="col-lg-1 col-md-2 col-xs-2 "><p class="traveller-heading--des">Title   </p><p class="traveller-heading" id="traveller-title_1">'+msg.travellersDetails[i].title+'</p></div>';
                        trHTML +='<div class="col-lg-6 col-md-2 col-xs-6 "><p class="traveller-heading--des">Name</p><p class="traveller-heading" id="traveller-name_1">'+(msg.travellersDetails[i].givenName)+'&nbsp'+(msg.travellersDetails[i].lastname)+'</p></div></th></tr>'
                        trHTML +='<tr ><th><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-6 col-xs-5"><a><p  class="traveller-heading--des traveller_hide'+(i+1)+' show-traveller-details" data-show="traveller'+(i+1)+'" href="#">Details<span class="fa fa-angle-down" style="margin-left: 5px;"></span> </p><p></p></a></div></th></tr>'                                   
                        trHTML += '<tr class="traveller'+(i+1)+' hidden"><th ><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-2 col-xs-5 "><p class="traveller-heading--des">Date Of Birth</p><p class="traveller-heading" id="traveller-dob_1">'+msg.travellersDetails[i].dob+'</p></div>'
                        trHTML +='<div class="col-lg-6 col-md-2 col-xs-5 "><p class="traveller-heading--des">Traveller type</p><p class="traveller-heading" id="traveller-type_1">'+traveler_type+'</p></div></th></tr>';
                        trHTML +='<tr class="traveller'+(i+1)+' hidden"><th ><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-2 col-xs-5 "><p class="traveller-heading--des">Passport</p><p class="traveller-heading" id="traveller-passportno_'+(i+1)+'"> '+msg.travellersDetails[i].passportnumber+'</p></div>';
                        trHTML +='<div class="col-lg-6 col-md-2 col-xs-5 "><p class="traveller-heading--des">Expiry Date</p><p class="traveller-heading" id="traveller-expirydate_1">'+expiry_date+'</p></div></th></tr>';
                        trHTML +='<tr class="traveller'+(i+1)+' hidden"><th ><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-6 col-xs-10 "><p class="traveller-heading--des">Passport Issuing Country</p><p class="traveller-heading" id="traveller-issuingcountry_'+(i+1)+'">'+country+' </p></div></th></tr>';
                        trHTML +='<tr class="traveller'+(i+1)+' hidden"><th ><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-2 col-xs-5 "><p class="traveller-heading--des">Nationality</p><p class="traveller-heading" id="traveller-nationality_'+(i+1)+'">'+nationality+'</p></div></th></tr>';
                        trHTML +='<tr class="traveller'+(i+1)+' hidden"><th ><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-6 col-md-6 col-xs-10 "><p class="traveller-loyality">Loyality Program Number</p></div></th></tr>'
                        trHTML +='<tr class="traveller'+(i+1)+' hidden"><th ><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-6 col-xs-5 "> <p class="traveller-heading--des">Airline</p> <p class="traveller-heading" id="traveller-airline_'+(i+1)+'">'+airlinename+'</p></div>'
                        trHTML +='<div class="col-lg-6 col-md-2 col-xs-5  airline_no_mob"><p class="traveller-heading--des">Number</p><p class="traveller-heading" id="traveller-airlineno_'+(i+1)+'">'+msg.travellersDetails[i].airlinenumber+'</p> </div></th></tr>'
                        trHTML +='<tr class="traveller'+(i+1)+' hidden"><th><div class="col-lg-1 col-md-2 col-xs-1"><p class="hidden">1</p></div><div class="col-lg-4 col-md-6 col-xs-6"><a><p class="traveller-heading--des hide-traveller-details" data-hide="traveller_hide'+(i+1)+'" data-show="traveller'+(i+1)+'" href="#">Show Less<span class="fa fa-angle-up" style="margin-left: 5px;"></span> </p><p></p></a></div></th></tr>'                                   
                        trHTML +='<tr><th style="text-align: end;"><div class="col-lg-12 col-md-2 col-xs-12 " style=""><a style="font-size: 21px;margin-right: 20px;" id="edittraveller-details'+(i+1)+'" class="fa fa-edit edittraveller-details" data-table-name="travellers'+(i+1)+'" data-form-name="firsttraveller_'+(i+1)+'"><p></p></a><a href="#mytraveller-popup" class="deletetraveller-details open-popup-link" id="index_'+(i+1)+'" data-index="'+msg.travellersDetails[i].index+'" data-traveler="'+(msg.travellersDetails[i].givenName)+'&nbsp'+(msg.travellersDetails[i].lastname)+'" style=" color: red;text-decoration: none;margin-right: 10px;"> <div class="fa fa-trash" style="font-size: 21px;"></div></a></div></th></tr>' 
                        trHTML +='</tbody></table>';
                        trHTML +='<div id="updatetraveller-detail_'+(i+1)+'" class="edittraveller-details'+(i+1)+' hide edit_form" style="display: block;"><div class="members-content-container member-profile-edit "><form class="form" id="member-profile-edit'+(i+1)+'" data-parsley-validate="" novalidate=""><fieldset class="error-validation"></fieldset><fieldset class="fieldset personal-details"><div class="form-group personal-detailsid"><p class="circle-travel">'+(i+1)+'</p><div class="edit">Edit</div></div>'
                        trHTML +='<div class="form-group edit-profile--titlefirsttraveller_'+(i+1)+'"><div class="row"><div class="col-xs-12 col-sm-2 edit-traveller-idfirsttraveller_'+(i+1)+'"><div class="form-item"><!-- select field (id)--><label class="label required" for="firsttraveller_'+(i+1)+'edit-profile--title">Title </label><select class="firsttraveller_'+(i+1)+'edit-profile--title" name="title" id="firsttraveller_'+(i+1)+'edit-profile--title" required="required" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-profile--title--error-container"></select>'
                        trHTML +='<div class="error_msg" id="firsttraveller_'+(i+1)+'edit-profile--title--error-container"></div></div></div></div><div class="row tag">Your name must be as stated on your personal identification or passport</div></div><div class="form-group edit-profile--name"><div class="row"><div class="col-xs-12 col-sm-5 edit-profile--first-name"><div class="form-item"><label class="label required" for="firsttraveller_'+(i+1)+'edit-profile--first-name">First / Given Name </label><input class="form-control firsttraveller_'+(i+1)+'edit-profile--first-name" name="first-name" type="text" id="firsttraveller_'+(i+1)+'edit-profile--first-name" required="required" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-profile--first-name--error-container" data-parsley-pattern="^[a-z A-Z]+$" maxlength="25"><div class="error_msg" id="firsttraveller_'+(i+1)+'edit-profile--first-name--error-container"></div></div></div><div class="col-xs-12 col-sm-5 edit-profile--last-name"><div class="form-item"><label class="label required" for="firsttraveller_'+(i+1)+'edit-profile--last-name">Last / Surname</label><input class="form-control firsttraveller_'+(i+1)+'edit-profile--last-name" name="last-name" type="text" id="firsttraveller_'+(i+1)+'edit-profile--last-name" required="required" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-profile--last-name--error-container" data-parsley-pattern="^[a-z A-Z]+$" maxlength="40" minlength="2"><div class="error_msg" id="firsttraveller_'+(i+1)+'edit-profile--last-name--error-container"></div></div></div></div><div class="form-group edit-profile--birth-dob"><div class="row"><div class="col-xs-12 col-sm-4 edit-profile--date-of-birthfirsttraveller_'+(i+1)+'"><div class="form-item"><label class="label required" for="firsttraveller_'+(i+1)+'edit-profile--date-of-birth">Date of Birth</label><input class="datepicker form-control firsttraveller_'+(i+1)+'edit-profile--date-of-birth " name="date-of-birth" type="text" id="firsttraveller_'+(i+1)+'edit-profile--date-of-birth" required="required" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-profile--date-of-birth--error-container" readonly="readonly"><span class="datepicker-icon"><i class="fa fa-calendar" aria-hidden="true" aria-label=""></i></span><div class="error_msg" id="firsttraveller_'+(i+1)+'edit-profile--date-of-birth--error-container"></div></div></div></div></div></fieldset><fieldset class="fieldset passport-information"><legend>Passport</legend><div class="form-group"><div class="row"><div class="col-xs-12 col-sm-4 add-passport--number"><div class="form-item"><label class="label" for="firsttraveller_'+(i+1)+'edit-profile--passport-number">Passport Number</label><input class="form-control firsttraveller_'+(i+1)+'edit-profile--passport-number" name="passport-number" type="text" id="firsttraveller_'+(i+1)+'edit-profile--passport-number" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-profile--passport-number--error-container" data-parsley-pattern="^[a-zA-Z0-9]+$"><div class="error_msg" id="firsttraveller_'+(i+1)+'edit-profile--passport-number--error-container"></div></div></div>'
                        trHTML +='<div class="col-xs-12 col-sm-4 edit-profile--passport-expiryfirsttraveller_'+(i+1)+'"><div class="form-item edit-profile--passport-details"><label class="label" for="firsttraveller_'+(i+1)+'edit-profile--passport-expiry-date">Expiry Date</label><input class="datepicker form-control firsttraveller_'+(i+1)+'edit-profile--passport-expiry-date " name="passport-expiry-date" type="text" id="firsttraveller_'+(i+1)+'edit-profile--passport-expiry-date" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-profile--passport-expiry-date--error-container" readonly="readonly"><span class="datepicker-icon"><i class="fa fa-calendar" aria-hidden="true" aria-label=""></i></span><div class="error_msg" id="firsttraveller_'+(i+1)+'edit-profile--passport-expiry-date--error-container"></div></div></div></div><div class="row"> <div class="col-xs-12 col-sm-4 edit-traveller-passport-issue-countryfirsttraveller_'+(i+1)+'"> <div class="form-item"> <!-- select field (id)--> <label class="label" for="firsttraveller_'+(i+1)+'edit-traveller--passport-issue-country">Passport Issue Country </label> <select class="firsttraveller_'+(i+1)+'edit-traveller--passport-issue-country" name="passport-issue-country" id="firsttraveller_'+(i+1)+'edit-traveller--passport-issue-country" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-traveller--passport-issue-country--error-container"> <option value=""> </option> <option value=""> <option value="Uzbekistan">Uzbekistan </option> <option value="Vietnam">Vietnam </option> <option value="Zambia">Zambia </option> </select> <div class="error_msg" id="firsttraveller_'+(i+1)+'edit-traveller--passport-issue-country--error-container"></div> </div> </div> <div class="col-xs-12 col-sm-4 edit-traveller-nationality"> <div class="form-item"> <!-- select field (id)--> <label class="label required" for="firsttraveller_'+(i+1)+'edit-traveller--nationality">Nationality </label> <select class="firsttraveller_'+(i+1)+'edit-traveller--nationality" name="nationality" id="firsttraveller_'+(i+1)+'edit-traveller--nationality" required="required" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-traveller--nationality--error-container"> <option value=""> </select> <div class="error_msg" id="firsttraveller_'+(i+1)+'edit-traveller--nationality--error-container"></div> </div> </div> </div></fieldset>'              
                        trHTML +='<fieldset class="fieldset contact-information"> <legend>Loyalty Program Number</legend> <div class="form-group loyality-programmer"> <div class="row"> <div class="col-xs-12 col-sm-2 col-sm-4 addtravellerairline"> <div class="form-item">  <label class="label" for="firsttraveller_'+(i+1)+'edit-traveller--airline-name">Airline </label> <select class="firsttraveller_'+(i+1)+'edit-traveller--airline-name" name="airline-name" id="firsttraveller_'+(i+1)+'edit-traveller--airline-name" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-traveller--airline-name--error-container"> <option value=""> </option> <option value=""> </option> <option value="American Airlines">American Airlines </option> <option value="British Airways">British Airways </option> <option value="Cathay Dragon">Cathay Dragon </option> <option value="Cathay Pacific">Cathay Pacific </option> <option value="Emirates">Emirates </option> <option value="Etihad Airways">Etihad Airways </option> <option value="Finnair">Finnair </option> <option value="Iberia">Iberia </option> <option value="Japan Airlines">Japan Airlines </option> <option value="KLM Royal Dutch Airlines">KLM Royal Dutch Airlines </option> <option value="LATAM Airlines Group">LATAM Airlines Group </option> <option value="Malaysia Airlines">Malaysia Airlines </option> <option value="Qantas Airways">Qantas Airways </option> <option value="Qatar Airways">Qatar Airways </option> <option value="Royal Jordanian">Royal Jordanian </option> <option value="Siberia Airlines">Siberia Airlines </option><option value="Singapore Airlines">Singapore Airlines </option><option value="SriLankan Airlines">SriLankan Airlines </option> </select> <div class="error_msg" id="firsttraveller_'+(i+1)+'edit-traveller--airline-name--error-container"></div> </div> </div> <div class="col-xs-12 col-sm-1 col-sm-2 add-traveller-Airline-code"> <div class="form-item"> <label class="label" for="firsttraveller_'+(i+1)+'edit-traveller--airline-codevalue" style="background-color: rgb(238, 238, 238); border-top-left-radius: 10px; border-top-right-radius: 10px;">Airline code </label> <input class="form-control firsttraveller_'+(i+1)+'edit-traveller--airline-codevalue" name="airline-codevalue" type="Airline code" id="firsttraveller_'+(i+1)+'edit-traveller--airline-codevalue" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-traveller--airline-codevalue--error-container" disabled=""> <div class="error_msg" id="firsttraveller_'+(i+1)+'edit-traveller--airline-codevalue--error-container"></div> </div> </div> <div class="form-item"> <label class="label" for="firsttraveller_'+(i+1)+'edit-traveller--airline-code"> </label> <input class="form-control firsttraveller_'+(i+1)+'edit-traveller--airline-code" name="airline-code" type="hidden" id="firsttraveller_'+(i+1)+'edit-traveller--airline-code" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-traveller--airline-code--error-container"> <div class="error_msg" id="firsttraveller_'+(i+1)+'edit-traveller--airline-code--error-container"></div> </div> <div class="col-xs-12 col-sm-4 col-sm-4 add-traveller-airline-number"> <div class="form-item"> <label class="label" for="firsttraveller_'+(i+1)+'edit-traveller--airline-number">Number </label> <input class="form-control firsttraveller_'+(i+1)+'edit-traveller--airline-number" name="airline-number" type="text" id="firsttraveller_'+(i+1)+'edit-traveller--airline-number" data-parsley-errors-container="#firsttraveller_'+(i+1)+'edit-traveller--airline-number--error-container" data-parsley-type="number" maxlength="20"> <div class="error_msg" id="firsttraveller_'+(i+1)+'edit-traveller--airline-number--error-container"></div> </div> </div> </div> </div> </fieldset> '
                        trHTML +='<fieldset class="fieldset"><row><div class="col-xs-5 col-sm-3" style="margin-left: 158px;"><a class="btn btn-primary submit btn-member--submit btn-member--addsubmitlcp" data-form-name="firsttraveller_'+(i+1)+'" data-editform-name="member-profile-edit'+(i+1)+'" id="update">Update</a></div><div class="col-xs-5 col-sm-3"><a class="btn btn-secondary submit btn-member--cancel cancelmytraveller-edit" data-table-name="travellers'+(i+1)+'" id="edittraveller-details'+(i+1)+'">Cancel</a></div></row></fieldset><input type="hidden" name="action" id="action" value="update"><input type="hidden" name="index" id="index_'+(i+1)+'" value="'+msg.travellersDetails[i].index+'"><input class="ids" type="hidden" name="ids" value="firsttraveller_'+(i+1)+'"><input type="hidden" name="email" id="email_2" value=""></div></div></form></div></div>'
    
                    }
                        $('#member-myadd-lcptraveller').append(trHTML);
			            bcommon.preloaderClose();
                }
                ,
			    error: function(error:any) 
			    {
                $('#member-myadd-traveller').hide();
                $(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
                $('html, body').animate({ scrollTop: '100px' });
                bcommon.preloaderClose();
			    }
            });
            // let _self = this;
            var titleInput = $('#add-profile--title');
            var getTitleOptions = $.Deferred();
            let titlecodeurl:string = '';
    
            if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                titlecodeurl = '/dummy-data/TitleCode.json';
            }
            else {
                titlecodeurl = '/content/dam/mas/json/TitleCodeLCP.json';
            }
    
            $.get(titlecodeurl)
            .done((data:any) => {
                var listItems = "<option value=''> </option>";
                    if (typeof data === 'string') {
                        data=JSON.parse(data);
                    }
                
                for (var i = 0; i < data.Titles.length; i++) {
                    listItems += "<option value='" + data.Titles[i].Code + "'>" + data.Titles[i].Name + "</option>";
                }
                getTitleOptions.resolve(listItems);
            })
            .fail((error:any) => {
                getTitleOptions.reject(error);
            });
    
            var airlineInput = $('#add-traveller--airline');
    
            var getairlineOptions = $.Deferred();
    
            let airlinecodeurl:string ='';
            if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                airlinecodeurl = '/dummy-data/airlinecode.json';
            }
            else {
                airlinecodeurl = '/content/dam/mas/json/airlinecode.json';
            }
    
            $.get(airlinecodeurl)
            .done((data:any) => {
                var listItems = "<option value=''> </option>";
                    if (typeof data === 'string') {
                        data=JSON.parse(data);
                    }
                
                for (var i = 0; i < data.airlinenames.length; i++) {
                    listItems += "<option value='" + data.airlinenames[i].Code + "'>" + data.airlinenames[i].Name + "</option>";
                }
                getairlineOptions.resolve(listItems);
            })
            .fail((error:any) => {
                getairlineOptions.reject(error);
            });	
    
            
            let countrycodeurl:string ='';
            var countryInput = $('#add-traveller--passport-issue-country');
            var getCountryOptions = $.Deferred();
            if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                countrycodeurl = '/dummy-data/countrycode.json';
            }
            else {
                countrycodeurl = '/content/dam/mas/json/countrycode.json';
            }
            $.get(countrycodeurl)
            .done((data:any) => {
                var listItems = "<option value=''> </option>";
                    if (typeof data === 'string') {
                        data=JSON.parse(data);
                    }
                    
                for (var i = 0; i < data.Countries.length; i++) {
                    listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
                }
                getCountryOptions.resolve(listItems);
            })
            .fail((error:any) => {
                getCountryOptions.reject(error);
            });
    
            var nationalityInput = $('#add-traveller--nationality');
            
    
            var getNationalityOptions = $.Deferred();
            $.get(countrycodeurl)
            .done((data:any) => {
                var listItems = "<option value=''> </option>";
                //if (window.location.hostname === 'localhost' && window.location.port == '5000') {
                    if (typeof data === 'string') {
                        data=JSON.parse(data);
                    //}
                }			
                for (var i = 0; i < data.Countries.length; i++) {
                    listItems += "<option value='" + data.Countries[i].Name + "'>" + data.Countries[i].Name + "</option>";
                }
                getNationalityOptions.resolve(listItems);
            })
            .fail((error:any) => {
                getNationalityOptions.reject(error);
            });
    
            $.when(getTitleOptions, getCountryOptions,getairlineOptions).done(function(titleOptions:any, countryOptions:any,airlineOptions:any) {
                titleInput.html(titleOptions);
                countryInput.html(countryOptions);
                nationalityInput.html(countryOptions);
                airlineInput.html(airlineOptions);
    
                var inputSelectArr = $.makeArray($('#member-profile-lcpadd').find('select'));
                _self.memberBase.initSelectizeInputs(inputSelectArr);
                for (var i=0;i<10;i++){
                    $('#firsttraveller_'+i+'edit-profile--title').html(titleOptions);
                    $('#firsttraveller_'+i+'edit-traveller--passport-issue-country').html(countryOptions);
                    $('#firsttraveller_'+i+'edit-traveller--nationality').html(countryOptions);
                    $('#firsttraveller_'+i+'edit-traveller--airline-name').html(airlineOptions);
                    
                    var inputSelectArr = $.makeArray($('#member-profile-edit'+i).find('select'));
                    _self.memberBase.initSelectizeInputs(inputSelectArr);
                }
                let inputDateArr1   = $('.edit-profile--birth-dob input');
                let inputDateArr2  = $('.edit-profile--passport-details input');
                let minDate = new Date((new Date().getFullYear() - 100).toString());
                let $ibeNowDate:any      = new Date();
                let $ibeTodayDate:any    = new Date($ibeNowDate.getFullYear(), $ibeNowDate.getMonth(), $ibeNowDate.getDate(), 0, 0, 0, 0);
                let maxDays: any = $('[data-ibe-datepicker-days]').length > 0 ? parseInt($('[data-ibe-datepicker-days]').attr('data-ibe-datepicker-days')) : 361;                
                let expiryminDate = new Date((new Date().getFullYear() - 100).toString());
		        let expirymaxDate = new Date((new Date().getFullYear() + 100).toString());
                let $addProfileFlag:any   		= $('#addProfileFlag').val();
                _self.memberBase.initDatepickerInputs(inputDateArr1, minDate, maxDays);
                _self.memberBase.initDatepickerInputs(inputDateArr2, expiryminDate, expirymaxDate);
                _self.editmytraveller();
                
            });
        });
 }
    displaydetails():any
    {
        $(document).on("click", ".show-traveller-details", function(){
            $(this).addClass('hidden');
            var show_details=$(this).attr("data-show");
            $('.'+show_details).removeClass('hidden');
         });

         $(document).on("click", ".hide-traveller-details", function(){
            var show_details=$(this).attr("data-show");
            var hide_details=$(this).attr("data-hide");
            $('.'+show_details).addClass('hidden');
            $('.'+hide_details).removeClass('hidden');
         });
    }
    editmytraveller(): any {
        
		let _self = this;
        $(document).on("click", ".edittraveller-details", function(){
        $('.member-profile-edit .error-validation').css({ 'display': 'none'});
        $('.member-profile-edit .form-item').removeClass('has-error');
        $('.mytraveler-table').css({ 'opacity': '0.5','pointer-events': 'none' });
        $('.btn-memberadd--submit').css({ 'opacity': '0.5','pointer-events': 'none' });
        $('#addtraveller_mobileadd').css({ 'opacity': '0.5','pointer-events': 'none' });
        var classname=this.id;
        var table_name=this.getAttribute('data-table-name')
        $('.'+classname).removeClass('hide');
        $('.'+table_name).addClass('hide');
        let editTraveller:any;
		let disableallothers:any;
        let showeditform:any;
        var form_name=this.getAttribute('data-form-name')
        editTraveller = form_name;
        let index:any;
        var form_name=this.getAttribute('data-form-name')
        editTraveller = form_name;
        index=form_name.split('_')[1];
		//  $(window).unbind('scroll');
		//  evt.preventDefault();
        //  evt.stopPropagation();
		 let formData:Array<any> = [];
        let populateurl:string = '';
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/addtraveller.json';
		}
		else {
		populateurl = '/bin/services/new/getMytravellerAPI';
		}
        
        
        $.ajax({
			type: 'GET',
			url:populateurl,
			success: function(msg:any) {
				
				//_self.redirectUser(msg);
				if(msg != "{}")
				{
					let inputFields = {
						'title': 		 				editTraveller+'edit-profile--title',
						'firstName': 	 				editTraveller+'edit-profile--first-name',
						'lastName': 	 				editTraveller+'edit-profile--last-name',
						'birthDate': 	 				editTraveller+'edit-profile--date-of-birth',
						'passportnumber': 				editTraveller+'edit-profile--passport-number',
						'passportExpiryDate':   		editTraveller+'edit-profile--passport-expiry-date',
						'passportissuingcountry': 		editTraveller+'edit-traveller--passport-issue-country',
						'nationality': 		 			editTraveller+'edit-traveller--nationality',
						'airline': 						editTraveller+'edit-traveller--airline-name-selectized',
						'airlinecode': 					editTraveller+'edit-traveller--airline-codevalue',
						'airlinenumber':  				editTraveller+'edit-traveller--airline-number',
						'airlinecodehid':  				editTraveller+'edit-traveller--airline-code',
						'nric':  				        editTraveller+'add-user--NRIC--number'
					}; 
					let res;			
					res =msg;
					let i;
					i= (index-1);
					let airlinecode=msg.travellersDetails[i].airlinecode
					   switch(airlinecode)
						{
						case 'AA' :
						$("#traveller-airline_"+i).html('American Airlines');
						var airlinename='American Airlines';
						break;
						case 'BA':
						var airlinename='British Airways';
						break;
						case 'KA' :
						var airlinename='Cathay Dragon';
						break;
						case 'CX' :
						var airlinename='Cathay Pacific';
						break;
						case 'EK' :
						var airlinename='Emirates';	
						break;
						case 'EY' :
						var airlinename='Etihad Airways';	
						break;
						case 'AY' :
						var airlinename='Finnair';
						break;
						case 'IB' :
						var airlinename='Iberia';
						break;
						case 'JL' :
						var airlinename='Japan Airlines';
						break;
						case 'KL' :
						var airlinename='KLM Royal Dutch Airlines';
						break;
						case 'LA' :
						var airlinename='LATAM Airlines Group';
						break;
						case 'MH' :
						var airlinename='Malaysia Airlines';
						break;
						case 'QF' :	
						var airlinename='Qantas Airways';	
						break;
						case 'QR' :	
						var airlinename='Qatar Airways';
						break;
						case 'RJ' :				
						var airlinename='Royal Jordanian';
						break;
						case 'S7' :						
						var airlinename='Siberia Airlines';
						break;
                        case 'SQ' :						
						var airlinename='Singapore Airlines';
						break;	
						case 'UL' :						
						var airlinename='SriLankan Airlines';
						break;		
						}
					var dobcont=res.travellersDetails[i].dob;
					var date_ofbirth = new Date(dobcont);
                    var expcont=res.travellersDetails[i].expirydate;
                    var exp_date = new Date(expcont);
					// if(expcont != "")
					// {
					// var exp_date = new Date(expcont);
					// }
 					let data = {

						'title': 						res.travellersDetails[i].title,
						'firstName': 					res.travellersDetails[i].givenName,
						'lastName': 					res.travellersDetails[i].lastname,
						'birthDate': 					date_ofbirth,
						'passportnumber':				res.travellersDetails[i].passportnumber,
						'passportExpiryDate':			exp_date,
						'passportissuingcountry':		res.travellersDetails[i].passportissuingcountry,
						'nationality':					res.travellersDetails[i].nationality,
						'airline':						airlinename,
						'airlinecode':					res.travellersDetails[i].airlinecode,
						'airlinenumber':				res.travellersDetails[i].airlinenumber,
						'airlinecodehid':  				res.travellersDetails[i].airlinecode,
						'nric':  				        res.travellersDetails[i].nric,
						'isused':  				        res.travellersDetails[i].isused

					};
	
					$.each(inputFields, (param:any, inputId:any) => {
						// console.log(param, inputId, data[param]);
	
						let input:any = $('#'+inputId);
	
						// handle select inputs
						if (input.is('select')) 
						{
							input[0].selectize.setValue(data[param]);
						} else if (input.is('[type="checkbox"]')) {
						// handle checkbox inputs
							if (data[param]) {
								input.prop('checked', 'checked');
							}
						} else if (input.hasClass('datepicker')) {
							input.datepicker('setDate', data[param]);
							// handle date inputs
						} else {
							// handle all other inputs
							input.val(data[param]);
						}
	
						// handle group interests/festival inputs
						if (!input.length) {
							let inputGrp:any = $('[name="'+inputId+'"]');
							console.log(inputGrp.length, inputGrp);
	
							$.each(inputGrp, (i:number, inputEl:any) => {
								if ($.inArray(inputEl.value, data[param]) >= 0) {
									$(inputEl).prop('checked', 'checked');
								}
								$(inputEl)
							});
						}
	
						input.blur();
						// manually apply state to elements if not added by blur
						input.parent().find('label').addClass('input-filled');
						input.addClass('input-focused');
					});	
				}
					
			},
			error:function(msg:any){
				console.log(msg);
			}
		});	  
	});

}

addmytraveller():any
{
    let _self = this;
    // $('#addtraveller-detail').hide();
    _self.$scope.find('.btn-memberadd--submit').click((evt: any) => {
        adobeDataLayer.push('click', {
            'pageName': '',
            'pageType': 'Enrich Profile - Relationship',
            'clickName': 'click:btn-click:add-travellers',
            'componentType': 'btn',
            'componentName': 'Add travellers',
            'componentID': '',
            'attributes': []
        });
    $('#addtraveller-detail').show();
    $('.btn-memberadd--submit').hide();
    $('#addtraveller_mobileadd').hide();
    $(".user--claimed--msg").addClass("hideClass");
    $(".user--claimed--msg").removeClass("showClass");
    $('#member-profile-lcpadd input:not([id*="-selectized"],[id*="action"]), selectize, textarea').val('');
    var inputSelectArr = $.makeArray($('#member-profile-lcpadd').find('select'));
    $('#member-profile-lcpadd .error-validation').css({ 'display': 'none'});
    $('#member-profile-lcpadd .form-item').removeClass('has-error');
    $.each(inputSelectArr,function(i:number, el:any){
    el.selectize.clear();
    });	
    $('.mytraveler-table').css({ 'opacity': '0.5','pointer-events': 'none' });
     $(window).unbind('scroll');
     evt.preventDefault();
     evt.stopPropagation();
    });

    _self.$scope.find('#addtraveller_mobileadd').click((evt: any) => {
    $('#addtraveller-detail').show();
    $('#addtraveller_mobileadd').hide();
    $('.btn-memberadd--submit').hide();
    $(".user--claimed--msg").addClass("hideClass");
    $(".user--claimed--msg").removeClass("showClass");
    $('#member-profile-lcpadd input:not([id*="-selectized"],[id*="action"]), selectize, textarea').val('');
    var inputSelectArr = $.makeArray($('#member-profile-lcpadd').find('select'));
    $.each(inputSelectArr,function(i:number, el:any){
    el.selectize.clear();
    });
    $('.mytraveler-table').css({ 'opacity': '0.5','pointer-events': 'none' });
    $(window).unbind('scroll');
    evt.preventDefault();
    evt.stopPropagation();
    });
}
deletemytraveller():any
{
    let _self = this;
    $(document).on("click", ".deletetraveller-details", function(){
    let $deleteId:any = this.getAttribute('data-index');
    let $deletename:any = this.getAttribute('data-traveler');
    //$deleteId = $("#"+$deleteId).val();
    $("#deleteBox").val($deleteId);
    $('.removename').html($deletename+'<span style="color:#000;font-weight: 700">?</span>');
     $(window).unbind('scroll');
    $.magnificPopup.open({
    items: {
        src: '#mytraveller-popup'
    },
    type:'inline',
    midClick: true,
    closeBtnInside: false
    });
    //  evt.preventDefault();
    //  evt.stopPropagation();
    });

    $(document).on("click", ".btn-mytraveler--cancel", function(){
    $.magnificPopup.close()
    $(".mytravellererror_message").html("");
     $(window).unbind('scroll');
     this.preventDefault();
     this.stopPropagation();
    });

    $(document).on("click", ".btn-mytraveler--remove", function(){
		let indexedit:any = $("#deleteBox").val();	
		// indexedit = indexedit.split('x')[1]-1;
		// let i:any = $("#index_"+indexedit).val();
		$.magnificPopup.close();
		 $(window).unbind('scroll');
		//  evt.preventDefault();
        //  evt.stopPropagation();
	
			let data:any = {
				'action' : 'delete',
				'index' : indexedit
				}
			$.ajax({
					type: 'POST',
					data:data,
					url: '/bin/services/new/myTravellerDetailsAPI',
					success: function(msg:any) {
					if(typeof msg==='string'){
					msg = JSON.parse(msg);
					}else{
						msg=msg;
					}
					$(".mytravellererror_message").html("");
					_self.populatemytravelller();			
					},
					error: function(error:any) {
					$(".mytravellererror_message").html("Sorry, a general error occurred. Please try again later.");
					$('html, body').animate({ scrollTop: '100px' });
					}
				});

 	});
}
    cancelmytraveller()
    {
        $(document).on("click", ".cancelmytraveller-edit", function(){
            $('.mytraveler-table').css({ 'opacity': '1.0','pointer-events': 'auto' });
            $('.btn-memberadd--submit').css({ 'opacity': '1.0','pointer-events': 'auto' });
            $('#addtraveller_mobileadd').css({ 'opacity': '1.0','pointer-events': 'auto' });
            var classname=this.id;
            var table_name=this.getAttribute('data-table-name')
            $('.'+classname).addClass('hide');
            $('.'+table_name).removeClass('hide');
         });
         $(document).on("click", "#cancel-add-traveller", function()
         {
             $('#addtraveller-detail').hide();
             $('.btn-memberadd--submit').show();
             $('#addtraveller_mobileadd').show();
             $('.mytraveler-table').css({ 'opacity': '1.0','pointer-events': 'auto' });
         });
    }
    spousetraveller()
    {
        let populateurl;
		if (window.location.hostname === 'localhost' && window.location.port == '5000') {
			populateurl = '/dummy-data/spousetraveller.json';
		}
		else {
			populateurl = '/bin/services/new/getEnrichRelationshipDetailsLCP';
		}
		let _self = this;
		// let bcommon = _self.bookingformcommon;
		// bcommon.preloader();
		$.ajax({
			type: 'GET',
			url:populateurl,
			success: function(msg:any) {
				if(typeof msg==='string'){
				msg = JSON.parse(msg);
				}else{
					msg=msg;
                }
                let isForm=msg.isForm;
                let isPrincipal=msg.isPrincipal;
                let isSpouse=msg.isSpouse;
                if (isForm===false)
                {
                    $(' #spouse .members--platinum--spouse--form').removeClass('hide');
                }
                else if(isForm===true && isPrincipal===true)
                {
                    $(' #spouse .members--platinum--primarydetails--availableform').removeClass('hide');
                    $("input.primarymember-profile--enrich-id").val(msg.details[0].enrichID);
                    $("input.primarymember-profile--enrich-name").val(msg.details[0].name);
                    $("input.primarymember-profile--conatct-no").val(msg.details[0].contactNo);
                    $("input.primarymember-profile--email-adress").val(msg.details[0].emailID)
                }
                else if(isForm===true && isSpouse===true)
                {
                    $(' #spouse .members--platinum--spousedetails--availableform').removeClass('hide');
                    $("input.spouse-profile--enrich-id").val(msg.details[0].enrichID);
                    $("input.spouse-profile--enrich-name").val(msg.details[0].name);
                    $("input.spouse-profile--conatct-no").val(msg.details[0].contactNo);
                    $("input.spouse-profile--email-adress").val(msg.details[0].emailID)
                }

                // bcommon.preloaderClose();
            }, error: function(error:any) {
                $("#spouse").html("Sorry, a general error occurred. Please try again later.");
                // bcommon.preloaderClose();
            }
        
        });
    }
    trackClickEvent() {
        let travelerObj = {
            'My Traveller': 'my-traveller',
            'Nominee': 'nominee',
            'Pool Members': 'pool-members'
        }
        $('.mytraveler_tab li a').click(function() {
            let tab = $(this).html();
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Relationship',
                'clickName': 'click:tab-click:'+travelerObj[tab],
                'componentType': 'tab',
                'componentName': tab,
                'componentID': tab,
                'attributes': []
            });
        });
        $('#update').click(function() {
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Relationship',
                'clickName': 'click:btn-click:add',
                'componentType': 'btn',
                'componentName': 'Add',
                'componentID': '',
                'attributes': []
            });
        });
        $('#add-newnomineeform--button').click(function () {
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Relationship',
                'clickName': 'click:btn-click:add-new-nominee',
                'componentType': 'btn',
                'componentName': 'nominee',
                'componentID': '',
                'attributes': []
            });
        });
        $('#add-nomineeform--button0').click(function () {
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Relationship',
                'clickName': 'click:btn-click:nominee-save',
                'componentType': 'btn',
                'componentName': 'nominee save',
                'componentID': '',
                'attributes': []
            });
        });
        $('#nominee-form--cancel0').click(function() {
            adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Relationship',
                'clickName': 'click:btn-click:add-nominee-cancel',
                'componentType': 'btn',
                'componentName': 'nominee save cancel',
                'componentID': '',
                'attributes': []
            });
        })
    }
}
let scope:Element = document.querySelector('#lcp_mytraveller_profile_members');

if (scope){
	try {
    let memberstraveller = new memberAddTraveller();
    var adobeDataLayer = new adobeDataLayerWrapper();
    memberstraveller.populatemytravelller();  
    memberstraveller.displaydetails(); 
    memberstraveller.editmytraveller();
    memberstraveller.addmytraveller();
    memberstraveller.deletemytraveller();
    memberstraveller.cancelmytraveller();
    memberstraveller.spousetraveller();
    memberstraveller.trackClickEvent();
    adobeDataLayer.push('pageLoaded', {
        'pageName': '',
        'pageType': 'Enrich Profile - Relationship',
        'attributes': []
    });
	} catch(e) {console.error(e);}
}